import React, { useEffect, useMemo, useState } from "react";
import {
  getFreeQuestionBankQuestionsApi,
  getQuestionBankQuestionsApi,
  regenerateSkillsApi,
} from "../../../../../api/candidate";
import WebUtils from "../../../../../utils/WebUtils";
import { Input, Pagination, Select, Skeleton, Space } from "antd";
import QuestionCard from "./QuestionCard";
import Icon from "../../../../../assets/Icon";
import Lottie from "react-lottie";
import noData from "../../../../../assets/lotties/guidePageNoData.json";
import bookLoader from "../../../../../assets/lotties/BookLoader.json";

const noDataJSON = {
  loop: false,
  autoplay: true,
  animationData: noData,
};
const loadingLottiFile = {
  loop: true,
  autoplay: true,
  animationData: bookLoader,
};

const MiddleViewQuestionBank = ({
  buttons,
  activeIndex,
  setActiveIndex,
  open,
  setOpen,
  currentSkills,
  setCurrentSkills,
  userDetail,
  jobGuideIdentifier,
  skillRegenerateFlag,
  setSkillRegenerateFlag,
  qbSkillType,
  setQBSkillType,
  industryId,
}) => {
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState(null);
  const [difficulty, setDifficulty] = useState(null);
  const [subSkill, setSubSkill] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchButtonText, setSearchButtonText] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const onPageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    getQBQuestionnaire(page - 1, size);
  };

  const subSkillOptions = useMemo(() => {
    return (
      currentSkills?.subSkillList?.map((label) => ({
        label,
        value: label,
      })) || []
    );
  }, [currentSkills]);

  useEffect(() => {
    setDifficulty(null);
    setSubSkill(null);
    setCurrentPage(1);
    setSearchText("");
    setSearchButtonText("");
  }, [currentSkills]);

  // Fetch whenever inputs change; allow null difficulty/subSkill
  useEffect(() => {
    const isValidSubSkill =
      subSkill == null || currentSkills?.subSkillList?.includes?.(subSkill);

    // Only require currentSkills to exist and subSkill (if present) to be valid
    if (currentSkills && isValidSubSkill) {
      getQBQuestionnaire(0, pageSize);
    }
  }, [currentSkills, difficulty, subSkill, searchButtonText]);

  // // Reset difficulty + subSkill when currentSkills change
  // useEffect(() => {
  //   setDifficulty("easy");

  //   if (subSkillOptions.length > 0) {
  //     setSubSkill(subSkillOptions[0].value);
  //   } else {
  //     setSubSkill(null);
  //   }
  // }, [subSkillOptions]);

  // useEffect(() => {
  //   const isValid = !!currentSkills?.subSkillList?.includes?.(subSkill);

  //   if (currentSkills && isValid && difficulty && subSkill) {
  //     getQBQuestionnaire(0, 5);
  //   }
  // }, [currentSkills, difficulty, subSkill, searchButtonText]);

  const getQBQuestionnaire = (currentPage, pageSize) => {
    const subskillNamePayload = subSkill ? encodeURIComponent(subSkill) : "";
    const difficultyPayload = difficulty ? encodeURIComponent(difficulty) : "";
    const searchValuePayload = searchButtonText
      ? encodeURIComponent(searchButtonText)
      : "";

    let url;

    if (industryId) {
      url = `${getFreeQuestionBankQuestionsApi}?userIdentifier=${
        userDetail?.userIdentifier || null
      }&jobGuideIdentifier=${jobGuideIdentifier}&skillType=${
        currentSkills?.skillType || qbSkillType || ""
      }&skillName=${encodeURIComponent(
        currentSkills?.skillName
      )}&subSkillName=${subskillNamePayload}&difficulty=${difficultyPayload}&searchValue=${searchValuePayload}&pageNumber=${currentPage}&pageSize=${pageSize}`;
    } else {
      url = `${getQuestionBankQuestionsApi}?userIdentifier=${
        userDetail?.userIdentifier || null
      }&jobGuideIdentifier=${jobGuideIdentifier}&skillType=${
        currentSkills?.skillType || qbSkillType || ""
      }&skillName=${encodeURIComponent(
        currentSkills?.skillName
      )}&subSkillName=${subskillNamePayload}&difficulty=${difficultyPayload}&searchValue=${searchValuePayload}&pageNumber=${currentPage}&pageSize=${pageSize}`;
    }

    setLoading(true);
    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setQuestions(result.data?.data?.jobSpecificPracticeQuestionList);
          setTotalCount(result.data?.data?.totalCount);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleSearch = () => {
    setSearchButtonText(searchText);
    // setCurrentPage(1);
    // getGenericGuideDataFunc(0, pageSize, searchText);
  };
  const handleClearSearch = () => {
    setSearchText("");
    setSearchButtonText("");
    // setCurrentPage(1);
    // getGenericGuideDataFunc(0, pageSize, "");
  };

  const handleRegenerateSkills = () => {
    let url = `${regenerateSkillsApi}?jobGuideIdentifier=${jobGuideIdentifier}&userIdentifier=${
      userDetail?.userIdentifier || null
    }&skillType=${currentSkills?.subTopicType || qbSkillType}`;

    // setBookmarkLoading(true);
    WebUtils.httpOperations(url, {}, "POST")
      .then((result) => {
        // setBookmarkLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setSkillRegenerateFlag({
            skillsBeingGenerated: true,
            noSkillsPresent: true,
          });
        }
      })
      .catch((err) => {
        // setBookmarkLoading(false);
        console.error(err);
      });
  };

  return (
    <>
      {skillRegenerateFlag?.skillsBeingGenerated ? (
        <div className="h-full flex flex-col justify-center items-center">
          <div className="w-full mx-auto">
            <Lottie
              style={{ width: "100%", maxWidth: "200px" }}
              options={loadingLottiFile}
            />
          </div>
          <div className="text-[#667085] text-[1.15rem] mx-auto text-center mt-[-1rem]">
            Questions are being generated
            <span className="dots text-left inline-block w-[10px]"></span>
          </div>
        </div>
      ) : skillRegenerateFlag?.noSkillsPresent ? (
        <div className="h-full flex flex-col justify-center items-center">
          <div className="w-full">
            <Lottie
              style={{ width: "100%", maxWidth: "300px" }}
              options={noDataJSON}
            />
          </div>
          <div className="text-[#667085] text-[1.1rem] mx-auto text-center">
            No questions found.
          </div>
          <button
            className="btn-orange px-[1rem] py-[0.45rem] text-[0.9rem] mt-3 flex gap-[0.6rem] items-center"
            onClick={handleRegenerateSkills}
          >
            Regenerate Questions
          </button>
        </div>
      ) : (
        <div className="custom-select text-[#475467] text-[0.94rem] h-full flex flex-col py-2 markdown-container">
          <div className="px-1 flex flex-wrap gap-3 justify-between items-center flex-shrink-0">
            <div className="flex flex-wrap gap-2 items-center">
              <Select
                allowClear
                placeholder="Difficulty"
                value={difficulty}
                onChange={setDifficulty}
                options={[
                  { label: "Easy", value: "easy" },
                  { label: "Medium", value: "medium" },
                  { label: "Hard", value: "hard" },
                ]}
                className="w-[105px]"
              />

              <Select
                className="w-[270px]"
                dropdownStyle={{ width: "w-[300px]" }}
                showSearch
                allowClear
                placeholder="Select a sub-skill"
                value={subSkill}
                onChange={setSubSkill}
                options={subSkillOptions}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </div>
            <div className="flex gap-2 flex-wrap items-center">
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="w-[250px] px-2 py-[0.36rem] border border-[#D0D5DD] shadow-sm"
                prefix={<Icon type="search-icon" />}
                placeholder="Search question"
                onPressEnter={handleSearch}
              />
              <button
                className="btn-orange py-[0.3rem] px-[.9rem] text-[.88rem]"
                onClick={handleSearch}
              >
                Search
              </button>
              {searchButtonText && (
                <button
                  className="btn-white py-[0.3rem] px-[.9rem] text-[.88rem]"
                  onClick={handleClearSearch}
                >
                  Clear
                </button>
              )}
            </div>
          </div>

          {/* Scrollable content section - takes remaining height */}
          <div className="flex-1 overflow-y-auto orange-scroll px-1 flex flex-col gap-[.85rem] mt-6 min-h-0">
            {loading ? (
              <div className="flex flex-col gap-3">
                <Skeleton.Button
                  block
                  active
                  style={{ width: "100%", height: 100, borderRadius: "12px" }}
                />
                <Skeleton.Button
                  block
                  active
                  style={{ width: "100%", height: 100, borderRadius: "12px" }}
                />
                <Skeleton.Button
                  block
                  active
                  style={{ width: "100%", height: 100, borderRadius: "12px" }}
                />
                <Skeleton.Button
                  block
                  active
                  style={{ width: "100%", height: 100, borderRadius: "12px" }}
                />
              </div>
            ) : questions && questions?.length > 0 ? (
              questions?.map((question, ind) => (
                <QuestionCard
                  key={question.id}
                  question={question}
                  jobGuideIdentifier={jobGuideIdentifier}
                  userDetail={userDetail}
                  industryId={industryId}
                  setLoading={setLoading}
                />
              ))
            ) : (
              <div className="text-center mt-4 text-[#475467]">
                No questions found.
              </div>
            )}
          </div>

          <div className="pt-2 flex flex-wrap gap-2 justify-center items-center border-t-2">
            <Pagination
              className="mx-auto"
              current={currentPage}
              total={totalCount}
              pageSize={pageSize}
              onChange={onPageChange}
              showSizeChanger={false}
            />
            {/* <div className="flex justify-end">
              <span className="border-2 rounded-md px-2 py-1 flex  gap-x-1 items-center">
                {buttons.map((btn, index) => {
                  const isActive = activeIndex === index && open;
                  return (
                    <button
                      key={index}
                      onClick={() => {
                        if (isActive) {
                          setOpen(false);
                          setActiveIndex(null);
                        } else {
                          setActiveIndex(index);
                          setOpen(true);
                        }
                      }}
                      className={`
             px-3 py-[6px] text-[0.9rem] flex gap-[0.6rem] items-center
            rounded-md transition-colors duration-200
            ${activeIndex === index ? "btn-orange" : ""}
            hover:bg-amber-300
          `}
                    >
                      {btn.id === 0 && (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.6663 5.41667C13.6663 4.56419 13.6663 4.13796 13.5726 3.78825C13.3184 2.83924 12.5771 2.09799 11.6281 1.8437C11.2784 1.75 10.8521 1.75 9.99967 1.75C9.1472 1.75 8.72096 1.75 8.37126 1.8437C7.42225 2.09799 6.681 2.83924 6.42671 3.78825C6.33301 4.13796 6.33301 4.56419 6.33301 5.41667M3.76634 18.25H16.233C17.2598 18.25 17.7732 18.25 18.1653 18.0502C18.5103 17.8744 18.7908 17.5939 18.9665 17.249C19.1663 16.8568 19.1663 16.3434 19.1663 15.3167V8.35C19.1663 7.32324 19.1663 6.80986 18.9665 6.41768C18.7908 6.07272 18.5103 5.79226 18.1653 5.61649C17.7732 5.41667 17.2598 5.41667 16.233 5.41667H3.76634C2.73958 5.41667 2.2262 5.41667 1.83403 5.61649C1.48906 5.79226 1.2086 6.07272 1.03283 6.41768C0.833008 6.80986 0.833008 7.32324 0.833008 8.35V15.3167C0.833008 16.3434 0.833008 16.8568 1.03283 17.249C1.2086 17.5939 1.48906 17.8744 1.83403 18.0502C2.2262 18.25 2.73958 18.25 3.76634 18.25Z"
                            stroke="#0F1B23"
                            stroke-width="1.67"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      )}
                      {btn.id === 1 && (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 14.8318L16.111 15.8043C15.6395 16.3199 15.0001 16.6096 14.3335 16.6096C13.6668 16.6096 13.0274 16.3199 12.5559 15.8043C12.0838 15.2897 11.4444 15.0008 10.7779 15.0008C10.1115 15.0008 9.47213 15.2897 8.99999 15.8043M1 16.6096H2.48848C2.92331 16.6096 3.14073 16.6096 3.34533 16.5605C3.52673 16.5169 3.70014 16.4451 3.8592 16.3476C4.03861 16.2377 4.19234 16.0839 4.49981 15.7765L15.6667 4.60958C16.4031 3.8732 16.4031 2.67929 15.6667 1.94291C14.9303 1.20653 13.7364 1.20653 13 1.94291L1.83312 13.1098C1.52565 13.4173 1.37192 13.571 1.26197 13.7504C1.1645 13.9095 1.09267 14.0829 1.04912 14.2643C1 14.4689 1 14.6863 1 15.1211V16.6096Z"
                            stroke="#475467"
                            stroke-width="1.67"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      )}
                      {btn.id === 2 && (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.70833 7.21822C7.70833 6.78071 7.70833 6.56195 7.79976 6.43983C7.87944 6.3334 8.0014 6.26682 8.13401 6.25734C8.28619 6.24648 8.4702 6.36477 8.83822 6.60136L13.1654 9.38314C13.4848 9.58843 13.6445 9.69108 13.6996 9.82161C13.7478 9.93565 13.7478 10.0643 13.6996 10.1784C13.6445 10.3089 13.4848 10.4116 13.1654 10.6169L8.83822 13.3986C8.4702 13.6352 8.28619 13.7535 8.13401 13.7427C8.0014 13.7332 7.87944 13.6666 7.79976 13.5602C7.70833 13.438 7.70833 13.2193 7.70833 12.7818V7.21822Z"
                            stroke="#475467"
                            stroke-width="1.67"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M1.75 6.15C1.75 4.60986 1.75 3.83978 2.04973 3.25153C2.31338 2.73408 2.73408 2.31338 3.25153 2.04973C3.83978 1.75 4.60986 1.75 6.15 1.75H13.85C15.3901 1.75 16.1602 1.75 16.7485 2.04973C17.2659 2.31338 17.6866 2.73408 17.9503 3.25153C18.25 3.83978 18.25 4.60986 18.25 6.15V13.85C18.25 15.3901 18.25 16.1602 17.9503 16.7485C17.6866 17.2659 17.2659 17.6866 16.7485 17.9503C16.1602 18.25 15.3901 18.25 13.85 18.25H6.15C4.60986 18.25 3.83978 18.25 3.25153 17.9503C2.73408 17.6866 2.31338 17.2659 2.04973 16.7485C1.75 16.1602 1.75 15.3901 1.75 13.85V6.15Z"
                            stroke="#475467"
                            stroke-width="1.67"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      )}
                    </button>
                  );
                })}
              </span>
            </div> */}
          </div>
        </div>
      )}
    </>
  );
};

export default MiddleViewQuestionBank;
